!function(o,t){"use strict";setInterval(function(){o.top==o.self&&o.top.location==location||(void 0!==o.stop?o.stop():void 0!==t.execCommand&&t.execCommand("Stop",!1),o.top.location.href='/')},3e3)}(window,document);



//////////////////
// WEBPACK FOOTER
// ./src/javascript/noiframe.js
// module id = 2
// module chunks = 0